const { String } = require('stdlib/String')
const { getDate } = require('./getDate')

/**
 * Visszaadja a `min` és `max` közötti órákat.
 * @param {string} min - A minimum DateTime.
 * @param {string} max - A maximum DateTime.
 * @returns {ReadonlyArray<string>} A megadott DateTime-ok közötti órák.
 */
module.exports.getHoursBetweenDateTimes = function getHoursBetweenDateTimes (min, max) {
  /**
   * A `date` időpontból kiveszi a dátumot és az órák számát.
   * @param {Date} date - Az aktuális időpont.
   * @returns {string} A `date`-ből kivett adat.
   */
  function getData (date) { // eslint-disable-line unicorn/consistent-function-scoping -- TODO: refakt.
    return `${ getDate(date.getTime()) } ${ String.pad(date.getHours()) }`
  }

  const minDate = new Date(min)
  const maxDateData = getData(new Date(max))

  let addHours = 1

    /**
     * @type {Array<string>}
     */
  const dates = [ getData(minDate) ]

  while (!dates.includes(maxDateData)) {
    const newDate = new Date(minDate)

    newDate.setHours(newDate.getHours() + addHours)

    dates.push(getData(newDate))

    addHours++
  }

  return dates
}
